module.exports = __webpack_public_path__ + "media/mkbg_2.7cceb81b.webm";